import { Breakpoint } from '@philips-emr/tws-constants';
import { Value } from '@philips-emr/tws-core';
import { AuthenticationService, MessageService } from '@philips-emr/tws-core/lib/services';
import { Validation } from '@philips-emr/tws-core/lib/services/model-service';
import { getBreakpoint } from '@philips-emr/tws-utils';

import { IeTipoContrato } from '../constants';
import TokenConstants from '../constants/token-constants';
import { ToastServiceStipulator } from '../services';

const NOT_RENDERED_COMPONENT_APIS = 'You should not access not rendered component apis.';

const CONFIRMATION_FIELD_VALID = 'confirmationField';

const PWD_VALIDATOR = 'passwordValidator';
const SENHA_NOVA_DIFERENTE_ATUAL = 'senhaNovaDiferenteDaAtual';

const PASSWORD = /^(?=.*?[A-Z])(?=(.*[a-z]))(?=(.*[\d]))(?=(.*[\W_])).{8,}$/;

function confirmationFieldValidator(value: Value, confirmationValue: Value): Validation[] {
  const valid = Boolean(value) && Boolean(confirmationValue) && confirmationValue === value;

  return [{
    message: !valid ? '$expression.$1042713' : '',
    name: CONFIRMATION_FIELD_VALID,
    valid,
  }];
}

function senhaNovaDiferenteDaAtual(value: Value, comparisonField: Value): Validation[] {
  const valid = value !== comparisonField;

  return [{
    message: !valid ? 'stipulator.senha-nova-igual-atual' : '',
    name: SENHA_NOVA_DIFERENTE_ATUAL,
    valid,
  }];
}

function passwordValidator(value: Value): Validation[] {
  const pass = value as string || '';
  const valid = Boolean(pass.match(PASSWORD)) && pass.length >= 8 && pass.length <= 16;

  return [{
    message: !valid ? '$expression.$1082772' : '',
    name: PWD_VALIDATOR,
    valid,
  }];
}

function catchRenderException(arg: () => void, defaultValue?: any): any {
  try {
    return arg();
  } catch (e) {
    if (e instanceof Error) {
      const ignoreErr = [NOT_RENDERED_COMPONENT_APIS];
      if (!ignoreErr.includes(e.message)) {
        console.error(e);
      }
      return defaultValue;
    }
  }
}

function onCatchError(message: string = 'stipulator.general-error'): void {
  ToastServiceStipulator.error(message);
}

function getFilterDates(startDateKey = 'dtInicio', endDateKey = 'dtFim', lessMonth = 1): Record<string, string> {
  const now = new Date();
  const lastMonth = new Date();
  lastMonth.setMonth(now.getMonth() - lessMonth);

  return {
    [startDateKey]: lastMonth.toISOString().slice(0, 10),
    [endDateKey]: now.toISOString().slice(0, 10),
  };
}

function shouldRenderMobile(): boolean {
  const breakpoint = getBreakpoint();
  return breakpoint === Breakpoint.SM || breakpoint === Breakpoint.XSM;
}

function getLabelTipoEstipulante(ieTipoEstipulante: string): string {
  return ieTipoEstipulante == 'PF'
    ? MessageService.translate('$expression.$286332') 
    : MessageService.translate('$expression.$284833');
}

function isIntercambio(): boolean {
  return getIeTipoContrato() === IeTipoContrato.I;
}

function isContrato(): boolean {
  return getIeTipoContrato() === IeTipoContrato.C;
}

function getIeTipoContrato(): IeTipoContrato | null {
  const token = AuthenticationService.getJWTToken();
  return token && token.claims[TokenConstants.IE_TIPO_CONTRATO] as IeTipoContrato;
}

export {
  CONFIRMATION_FIELD_VALID,
  PWD_VALIDATOR,
  SENHA_NOVA_DIFERENTE_ATUAL,
};

export {
  catchRenderException,
  onCatchError,
  confirmationFieldValidator,
  getFilterDates,
  getIeTipoContrato,
  getLabelTipoEstipulante,
  isContrato,
  isIntercambio,
  passwordValidator,
  shouldRenderMobile,
  senhaNovaDiferenteDaAtual,
};
